const snakeToCamel = str => str.replace(/([-_][a-z])/g, group => group.toUpperCase().replace('-', '').replace('_', ''))

const requestLoadingNames = request => ({
  get: 'getting',
  post: 'posting',
  put: 'putting',
  delete: 'deleting',
})[request]

const getRequestVarDefaults = (options = {}) => {
  const {
    hasData = true,
    hasLoading = true,
    hasError = true,
    pagination = false,
    dataName = 'data',
    loadingName = 'loading',
    errorName = 'error',
    countName = 'count',
  } = options
  const result = {}
  if (hasData) result[dataName] = []
  if (hasLoading) result[loadingName] = false
  if (hasError) result[errorName] = {}
  if (pagination) result[countName] = 0
  return result
}

const filterRequestVarNames = (options = {}) => {
  const {
    dataName = 'data',
    errorName = 'error',
    loadingName = 'loading',
    countName = 'count',
    hasData = true,
    hasError = true,
    hasLoading = true,
    pagination = false,
  } = options

  const result = {}
  if (hasData) result.data = dataName
  if (hasLoading) result.loading = loadingName
  if (hasError) result.error = errorName
  if (pagination) result.count = countName
  return result
}

const getRequestVarNames = (options = {}) => {
  const { identifier = null, request = 'get', loading = null, data = null, count = null, error = null, pagination = false } = options
  const dataName = data || snakeToCamel(`${identifier}-list`)
  const loadingName = loading || snakeToCamel(`${identifier}-${requestLoadingNames(request)}`)
  const errorName = error || snakeToCamel(`${identifier}-${request}-errors`)
  if (pagination) {
    const countName = count || snakeToCamel(`${identifier}-${request}-count`)
    return { dataName, loadingName, errorName, countName }
  }
  return { dataName, loadingName, errorName }
}

const modifyCustomerAttributesNames = (attributes = {}, options = {}) => {
  const { identifier = null } = options
  return Object.keys(attributes)
    .reduce((result, key) => {
      result[snakeToCamel(`${identifier}-${key}`)] = attributes[key] || null
      return result
    }, {})
}

const requestVars = (options = {}, customAttributes = {}) => {
  const varNames = getRequestVarNames(options)
  const extendedOptions = { ...options, ...varNames }
  const extendedAttributes = modifyCustomerAttributesNames(customAttributes, options)
  const result = getRequestVarDefaults(extendedOptions)
  const requestVarNames = filterRequestVarNames(extendedOptions)
  return [
    { ...result, ...extendedAttributes },
    requestVarNames,
  ]
}

export default requestVars
